export const  ReportRoutes = {
    getStats:"/auth/getReport",
    UpdateStats:"/auth/updateReport",
    getProgress:"/auth/getMyProgress",
    deleteReport:"/report/deleteSubmission"
  };
    